import { render } from "./BeverageMenu.vue?vue&type=template&id=31686744"
import script from "./BeverageMenu.vue?vue&type=script&lang=js"
export * from "./BeverageMenu.vue?vue&type=script&lang=js"

import "./BeverageMenu.vue?vue&type=style&index=0&id=31686744&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__